module.exports = __webpack_public_path__ + "static/media/FacebookSocial.c9e51621.svg";